export const STAKEHOLDER_MEMBER_TARGET_OPTIONS = [
  { value: "prospect", label: "Prospect" },
  { value: "dad_partner", label: "Dad Partner" },
  { value: "former", label: "Removed / Former" },
];

export const STAKEHOLDER_GUIDE_TARGET_OPTIONS = [
  { value: "prospect", label: "Prospect" },
  { value: "invited", label: "Invited" },
  { value: "active", label: "Active" },
  { value: "scheduled", label: "Scheduled" },
  { value: "completed", label: "Completed" },
  { value: "declined", label: "Declined / Removed" },
];

export const STAKEHOLDER_DISPOSITION_REASON_OPTIONS = [
  { value: "not_ready", label: "Not ready" },
  { value: "lost_contact", label: "Lost contact" },
  { value: "financial_hesitation", label: "Financial hesitation" },
  { value: "no_longer_fit", label: "No longer fit" },
  { value: "joined_elsewhere", label: "Joined elsewhere" },
  { value: "stopped_engaging", label: "Stopped engaging" },
  { value: "family_life_overload", label: "Family/life overload" },
  { value: "conflict_or_trust_break", label: "Conflict or trust break" },
  { value: "requested_removal", label: "Requested removal" },
  { value: "other", label: "Other" },
];
